<rds-card>
  <div class="card-content rds-padding-100">
    <h2 class="rds-heading-2 rds-margin-block-end-150">Get started</h2>
    <div class="profile-label-wrapper">
      <rds-input-label>
        <label for="profile-select" slot="label">Select profile</label>
      </rds-input-label>
    </div>

    <!-- Primary dropdown -->
    <rds-select
      id="profile-select"
      required
      [(ngModel)]="selectedConnector"
      (ngModelChange)="onConnectorChange($event)"
      class="dropdown"
      variant="outlined">
      <rds-option *ngFor="let option of connectorOptions" [value]="option.value">
        {{ option.viewValue }}
      </rds-option>
    </rds-select>

    <!-- Secondary dropdown (Location) - only when the selected connector needs it -->
    <div *ngIf="showLocationSelect">
      <rds-input-label class="profile-label-wrapper">
        <label for="location-select" slot="label">Location</label>
      </rds-input-label>

      <rds-select
        id="location-select"
        required
        [(ngModel)]="selectedLocation"
        class="dropdown"
        variant="outlined">
        <rds-option *ngFor="let loc of locationsForSelected" [value]="loc.value">
          {{ loc.viewValue }}
        </rds-option>
      </rds-select>
    </div>

    <rds-button (click)="start()" [disabled]="!canStart">
      Start
    </rds-button>
  </div>
</rds-card>